// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgWashingMachineIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-8 2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1M7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m6-14h-3V4h3zm-2 8c0 .52-.11 1.01-.29 1.46-1.47-.18-2.26-1.67-2.27-1.69-.17-.34-.72-.33-.89 0 0 .02-.9 1.73-2.55 1.73-.86 0-1.51-.46-1.94-.91-.03-.2-.06-.39-.06-.59 0-2.21 1.79-4 4-4s4 1.79 4 4m-.81 2.39C14.46 17.36 13.31 18 12 18c-1.39 0-2.61-.71-3.33-1.78.39.17.83.28 1.33.28 1.48 0 2.47-.92 3-1.59.42.54 1.15 1.23 2.19 1.49z" />
  </g>
);
export default SvgWashingMachineIcon;
SvgWashingMachineIcon.displayName = 'SvgWashingMachineIcon';
